import { UserSummary } from '@domain'
import { Avatar, Stack, StackProps, Typography } from '@mui/material'
import { getTestId, stringToColor } from '@utils/helpers'

type Props = StackProps & {
	user: UserSummary
	email?: boolean
	name?: boolean
	size?: 'small' | 'medium'
}

export default function UserAvatar({
	user,
	email = false,
	name = false,
	size = 'medium',
	...rest
}: Props) {
	const initials = user.firstName
		? `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`
		: user.email.slice(0, 2).toUpperCase()
	const testId = getTestId(rest, `user-${user.displayName}`)

	return (
		<Stack direction="row" spacing={1} alignItems="center" data-testid={testId} {...rest}>
			<Avatar
				src={user.profilePic}
				sx={{
					bgcolor: stringToColor(user.displayName),
					...(size === 'small' && { width: '1.875rem', height: '1.875rem', fontSize: '0.875rem' }),
				}}
			>
				{initials}
			</Avatar>
			{(name || email) && (
				<Stack>
					{name && (
						<Typography variant="body2">
							<b>{user.displayName}</b>
						</Typography>
					)}
					{email && (
						<Typography variant="body2" color="text.secondary">
							{user.email}
						</Typography>
					)}
				</Stack>
			)}
		</Stack>
	)
}
